/**
 * Type of authorizatiopn PDF file
 */
export enum AuthorizationPdfType  {
  /**
   * Generic PDF template for Employer / Worker
   */
  Person = "person",
  /**
   * Company authorization (employer).
   */
  Company = "company"
}